import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequestsService } from 'src/app/services/http-requests.service';

@Component({
  selector: 'app-learning-questions',
  templateUrl: './learning-questions.component.html',
  styleUrls: ['./learning-questions.component.scss']
})
export class LearningQuestionsComponent implements OnInit {

  public metas: any = [];
  public questions: any = [];
  public expanded: boolean = false;;
  public cities: any = [];

  constructor(private req: HttpRequestsService<any>, private router: Router) { }

  ngOnInit(): void {
      this.req.getAllMetas().subscribe((res) => {
      this.metas = res;
      this.metas.forEach(element => {
        element.expanded = false;
      });
    });
  }

  onClick(meta: string) {
    this.metas.forEach(element => {
      element.expanded = (element.Meta === meta) ? !element.expanded : false;
    });
  
    if (this.metas.find(metaItem => metaItem.Meta === meta)?.expanded) {
      this.req.getAllQuestions(meta).subscribe(res => this.questions = res);
    } else {
      this.questions = [];
    }
  }
  
  onLqClick(question) {
    this.questions.forEach(element => {
      if (element.LQ === question.LQ) {
        element.expanded = !element.expanded;
        if (element.expanded && !element.cities) {
          this.req.getCitiesofQuestions(question.LQ).subscribe(res => {
            element.cities = res;
          });
        }
      } else {
        element.expanded = false;
      }
    });
  }
  

  onCity(city) {
    this.router.navigateByUrl(`${city.City}/Actions`, { state: { city: city.City } });
  }
}